module.exports = __webpack_public_path__ + "img/37@2x.4cb1e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/37@2x.png
// module id = O5Ab
// module chunks = 0